import React from "react";

const Bell = ({ size = "14", fill = "none", color = "#1E84BE" }) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.7641 1.23833C4.9622 0.750356 5.44092 0.40625 6 0.40625C6.55909 0.40625 7.0378 0.750356 7.23591 1.23833C9.21345 1.78006 10.6667 3.59011 10.6667 5.73958V8.87107L11.888 10.7031C12.0244 10.9077 12.0371 11.1707 11.9211 11.3875C11.8051 11.6043 11.5792 11.7396 11.3333 11.7396H8.30971C8.14796 12.8703 7.17549 13.7396 6 13.7396C4.82451 13.7396 3.85204 12.8703 3.6903 11.7396H0.666668C0.420804 11.7396 0.194897 11.6043 0.0788846 11.3875C-0.0371281 11.1707 -0.024413 10.9077 0.111967 10.7031L1.33333 8.87107V5.73958C1.33333 3.59011 2.78655 1.78006 4.7641 1.23833ZM5.0569 11.7396C5.19418 12.128 5.5646 12.4062 6 12.4062C6.43541 12.4062 6.80582 12.128 6.9431 11.7396H5.0569ZM6 2.40625C4.15905 2.40625 2.66667 3.89863 2.66667 5.73958V9.07292C2.66667 9.20453 2.62771 9.33321 2.5547 9.44272L1.91235 10.4062H10.0877L9.4453 9.44272C9.37229 9.33321 9.33333 9.20453 9.33333 9.07292V5.73958C9.33333 3.89863 7.84095 2.40625 6 2.40625Z"
        fill={color}
      />
    </svg>
  );
};

export default Bell;
